export default function scrollToTop(element) {
  element.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}
